import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const routes = [
    {
        path: '/',
        name: 'Root',
        redirect: '/home'
    },
    {
        path: '/login',
        redirect: '/auth'
    },
    {
        path: '/auth/:mode?',
        name: 'Auth',
        component: () => import ('@/views/Auth/Auth.vue')
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import ('@/views/Home.vue'),
        meta: { requiresAuth: true, topbar: true, navigation: true, autopilot: true },
    },
    // {
    //     path: '/workspace',
    //     name: 'Workspace',
    //     component: () => import ('@/views/Workspace.vue'),
    //     meta: { requiresAuth: true, topbar: true, navigation: true, allowed: () => !store.state.embedded, autopilot: true },
    //     children: [
    //         { path: 'assessor', name: 'Workspace-Assessor', component: () => import ('@/views/Workspaces/Assessor.vue') },
    //     ]
    // },
    {
        path: '/roboteka',
        name: 'Roboteka',
        component: () => import ('@/views/Roboteka.vue'),
        meta: { requiresAuth: true, topbar: true, navigation: true, autopilot: true }
    },
    {
        path: '/launcher/:id?',
        name: 'ScriptLauncher',
        component: () => import ('@/views/ScriptLauncher.vue'),
        meta: { requiresAuth: true, topbar: true, navigation: true, autopilot: true }
    },
    {
        path: '/recorder',
        name: 'MacroRecorder',
        component: () => import ('@/views/MacroRecorder.vue'),
        meta: {
            requiresAuth: true,
            topbar: () => true,
            navigation: () => true,
            autopilot: true
        }
    },
    {
        path: '/smartbuilder',
        name: 'SmartBuilder',
        component: () => import ('@/views/SmartBuilder.vue'),
        meta: { requiresAuth: true, requiresPayment: true, topbar: true, navigation:() => !store.state.embedded, allowed: () => !store.state.embedded },
    },
    {
        path: '/notifications',
        name: 'NotificationsDashboard',
        component: () => import ('@/views/NotificationsDashboard.vue'),
        meta: {
            requiresAuth: true,
            topbar: true,
            navigation: true,
            // allowed: () => store.state.embedded,
            autopilot: true
        }
    },
    {
        path: '/flows/:id?',
        name: 'FlowsPanel',
        component: () => import ('@/views/FlowsPanel.vue'),
        meta: {
            requiresAuth: true,
            topbar: true,
            navigation: true,
            autopilot: true
        }
    },
    {
        path: '/workspace',
        name: 'WorkEnvironmentSetup',
        component: () => import ('@/views/WorkEnvironmentSetup.vue'),
        meta: {
            requiresAuth: true,
            topbar: true,
            navigation: true,
            allowed: () => true,//store.state.embedded,
            autopilot: true
        }
    },
    {
        path: '/altasybajas',
        name: 'AltasBajasDashboard',
        component: () => import ('@/views/Asesoria/AltasBajasDashboard.vue'),
        meta: { requiresAuth: true, topbar: true, navigation: true, autopilot: true }
    },
    {
        path: '/fie',
        name: 'FIE',
        component: () => import ('@/views/FIE.vue'),
        meta: { requiresAuth: true, topbar: true, navigation: true, autopilot: true, /*allowed: () => store.state.embedded*/ }
    },
    {
        path: '/documanager',
        name: 'DocumentManager',
        component: () => import ('@/views/DocumentManager.vue'),
        meta: {
            requiresAuth: true, topbar: true, navigation: true,
            allowed: () => store.state.currentUser?.userData?.group?.config?.allowed_routes?.includes('/documanager')
        }
    },
    {
        path: '/userprofile',
        name: 'UserProfile',
        component: () => import ('@/views/UserProfile.vue'),
        meta: { requiresAuth: true, topbar: true, navigation: true }
    },
    {
        path: '/payments',
        name: 'Payments',
        component: () => import ('@/views/Payments.vue'),
        meta: { requiresAuth: true, topbar: true, navigation: true }
    },
    {
        path: '/help',
        name: 'Help',
        component: () => import ('@/views/Help.vue'),
        meta: { requiresAuth: true, topbar: true, navigation: true }
    },
    {
        path: '/oauth-response',
        name: 'OauthResult',
        component: () => import ('@/views/OauthResult.vue'),
        meta: { requiresAuth: false, topbar: false, navigation: false, static: true }
    },
    {
        path: '/onboarding',
        name: 'OnBoarding',
        component: () => import ('@/views/OnBoarding.vue'),
        meta: { requiresAuth: true, topbar: true, navigation: true }
    },
    {
        path: '/online-form/:id?',
        name: 'OnlineForm',
        component: () => import ('@/views/OnlineForm.vue')
    },
    {
        path: '/info',
        name: 'Info',
        component: () => import ('@/views/Info/Info.vue')
    },
    {
        path: '/scraper',
        name: 'Scraper',
        component: () => import ('@/views/Scraper.vue'),
        meta: { requiresAuth: true, topbar: true, navigation: true },
    },
    {
        path: '/form/:context/:id?',
        name: 'DynamicForm',
        component: () => import ('@/views/DynamicForm.vue'),
        meta: { requiresAuth: false, topbar: false, navigation: false }
    },
    {
        path: '/frumecar',
        name: 'Frumecar',
        component: () => import ('@/views/Frumecar/index.vue'),
        meta: {
            requiresAuth: true, topbar: true, navigation: true,
            allowed: () => store.state.currentUser?.userData?.group?.config?.allowed_routes?.includes('/frumecar')
        },
    },
    {
        path: '/:catchAll(.*)',
        component: () => import ('@/views/PageNotFound.vue')
    },

    // ========== Develop routes ==========
    {
        path: '/debug-components',
        name: 'DebugComponents',
        component: () => import ('@/views/DebugComponents.vue'),
        meta: { requiresAuth: false, topbar: true, navigation: true, debug: true },
    },
]

const router = createRouter({
    routes,
    history: createWebHistory()
})

export default router